import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface NotificationsState {
  notificationsToken: string;
}

const initialState: NotificationsState = {
  notificationsToken: '',
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    updateNotificationsToken: (state, { payload }: PayloadAction<string>) => {
      state.notificationsToken = payload;
      return state;
    },
  },
  extraReducers: () => {},
});

export const { updateNotificationsToken } = notificationsSlice.actions;
